<template>
  <div id="gaoBaoBanToastRoot">
    <div id="gaoBaoBanToastContainer" :style="{'background':$store.state.baseColor}">
      <div id="gaoBaoBanToastMessageTagParent">
        <label>{{$store.state.toastMessage}}</label>
      </div>
    </div>
  </div>
 </template>
 
 <script>
  export default {
    data () {
      return {}
    },
    components: {
    },
    methods:{
      
    },
    created:function(){
      setTimeout(() => {
        let payload = {"showOrHide": false, "toastMessage": "无"}
        this.$store.commit("switchToast",payload)
      }, 1000);
    }
  }
 </script>
 
 <style>
#gaoBaoBanToastRoot{
    /* display: none; */
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    /* background: rgba(51,51,51,0.5); */
    z-index: 4233;
  }
  #gaoBaoBanToastContainer{
    width: auto;
    min-width: 300px;
    max-width: 100%;
    height: auto;
    min-height: 30px;
    position: absolute;
    top: 80%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 4255;
    border-radius: 20px 20px 20px 20px;
  }

  #gaoBaoBanToastMessageTagParent{
    width: auto;
    min-width: 300px;
    max-width: 100%;
    height: auto;
    min-height: 30px;
    display: -webkit-box;
    -webkit-box-orient: horizontal;
    -webkit-box-pack: center;
    -webkit-box-align: center;
    
    display: -moz-box;
    -moz-box-orient: horizontal;
    -moz-box-pack: center;
    -moz-box-align: center;
    
    display: -o-box;
    -o-box-orient: horizontal;
    -o-box-pack: center;
    -o-box-align: center;
    
    display: -ms-box;
    -ms-box-orient: horizontal;
    -ms-box-pack: center;
    -ms-box-align: center;
    
    display: box;
    box-orient: horizontal;
    box-pack: center;
    box-align: center;

    
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
    
  }
  #gaoBaoBanToastMessageTagParent label{
    /* position: absolute; */
    color: white;
    font-size: x-small;
    /* padding-left: 15px;
    padding-right: 15px; */
    /* margin-left: 15px;
    margin-right: 15px; */
  
    /* background-color: aquamarine; */
  }

 </style>


// WEBPACK FOOTER //
// src/views/GaoBaoBan/Toast.vue